import PropTypes from "prop-types";
import { classNamePropType, valuePropType } from "../../common";

/**
 * PropTypes for ChangeIndicator component
 *
 * @property {string|number} value - Formatted value to display (e.g., "+12.5%")
 * @property {number} change - Numeric change value for determining color (positive/negative)
 * @property {string} [className] - Additional CSS classes
 */
export const changeIndicatorPropTypes = {
  value: valuePropType.isRequired,
  change: PropTypes.number.isRequired,
  className: classNamePropType,
};
